export default function StandardContainer({ content, cssClasses = "" }) {
  return (
    <section
      className={`${cssClasses} container mx-auto max-w-screen-2xl px-4 sm:px-8 xl:px-12`}
    >
      {content}
    </section>
  );
}
